import classNames from 'classnames';
import React, { FC } from 'react';
import styles from './StickyBox.module.scss';

type StickyBoxProps = {
	offset?: boolean;
	className?: string;
};

export const StickyBox: FC<StickyBoxProps> = ({ offset = true, className, children }) => {
	return (
		<div
			className={classNames(styles.stickyBox, 'stickyBox', className, {
				[styles['stickyBox--offset']]: offset,
			})}
		>
			{children}
		</div>
	);
};
